import React from "react"
import PropTypes from "prop-types"
import Logo from "../images/wlh-logo.inline.svg"

import "./HeaderImage.css"

const HeaderImg = ({alt}) => (
  <div className="header-img">
    <Logo />
  </div>
)
export default HeaderImg

HeaderImg.propTypes = {
  alt: PropTypes.string,
}

HeaderImg.defaultProps = {
  alt: ``,
}

// NOTE: SVG's do not take an alt attribute for AMP pages